<template>
	<div class="knd-progress">
		<div class="knd-paragraaf">
			<div class="progress-container">
				<div 
					v-for="(answer) in answers" 
					:key="answer.id" 
					:title="`ga naar vraag ${answer.id}`"
					@click="(e) => onClick(e, `#vraag-${answer.id}`)"
				>
					<div class="progression-icon">
					<Box :answer="answer" :size="21"></Box>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { useStore } from 'vuex';
import Box from './box.vue';

export default {
	name: 'Progression',
	props: {
    answers: {
      type: Array
    }
  },
	components:{Box},
	setup() {
		const store = useStore();

		function onClick(e, id) {
			e.preventDefault();
			
			let pointerHeader = document.querySelector('.header__bar');
			let height = 0;

			if(pointerHeader) {
				height = pointerHeader.offsetHeight;
			}

			const element = document.querySelector(id);
			const topPos = element.getBoundingClientRect().top + window.pageYOffset - 42 -height;

			window.scrollTo({
				top: topPos, // scroll so that the element is at the top of the view
				behavior: 'smooth' // smooth scroll
			})

		}

		return {
			onClick
		}
	}
}
</script>


<style lang="scss">

.knd-progress {
  position: sticky;
	top: 0;
	z-index: 100;

	.knd-paragraaf {
		padding-top: var(--knd-spacing-md);
		padding-bottom: var(--knd-spacing-md);
	}

  background: $mint;
	box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);


	.progress-container {
		display: flex;
		justify-content: center;
	}

	.progression-icon {
		margin-right: 5px;
		cursor: pointer;
	}
 
}

</style>